import { moveRangeEndsIntoTextNodes } from "./range";
import { iterateWalker } from "./nodes";
export var FragmentSelectorConformsTo;
(function (FragmentSelectorConformsTo) {
    // Skipping: HTML, PDF, Plain Text, XML, RDF/XML, CSV, Media, SVG
    FragmentSelectorConformsTo["EPUB3"] = "http://www.idpf.org/epub/linking/cfi/epub-cfi.html";
})(FragmentSelectorConformsTo || (FragmentSelectorConformsTo = {}));
export function isFragment(selector) {
    return selector.type === 'FragmentSelector';
}
export function isCss(selector) {
    return selector.type === 'CssSelector';
}
export function isTextQuote(selector) {
    return selector.type === 'TextQuoteSelector';
}
export function isTextPosition(selector) {
    return selector.type === 'TextPositionSelector';
}
export function textPositionFromRange(range, root) {
    range = moveRangeEndsIntoTextNodes(range);
    let iter = root.ownerDocument.createNodeIterator(root, NodeFilter.SHOW_TEXT);
    let selector = {
        type: 'TextPositionSelector'
    };
    let pos = 0;
    for (let node of iterateWalker(iter)) {
        if (node === range.startContainer) {
            selector.start = pos + range.startOffset;
        }
        if (node === range.endContainer) {
            selector.end = pos + range.endOffset;
        }
        if (node.nodeValue) {
            pos += node.nodeValue.length;
        }
    }
    if (selector.start === undefined || selector.end === undefined) {
        return null;
    }
    return selector;
}
export function textPositionToRange(selector, root) {
    let iter = root.ownerDocument.createNodeIterator(root, NodeFilter.SHOW_TEXT);
    let range = root.ownerDocument.createRange();
    let pos = 0;
    for (let node of iterateWalker(iter)) {
        if (!node.nodeValue) {
            continue;
        }
        let startOffset = selector.start - pos;
        if (startOffset >= 0 && startOffset <= node.nodeValue.length) {
            range.setStart(node, startOffset);
        }
        let endOffset = selector.end - pos;
        if (endOffset >= 0 && endOffset <= node.nodeValue.length) {
            range.setEnd(node, endOffset);
        }
        pos += node.nodeValue.length;
    }
    return range;
}
